import { render, staticRenderFns } from "./EditH1GoodsItems.vue?vue&type=template&id=7b7d00cc&scoped=true&"
import script from "./EditH1GoodsItems.vue?vue&type=script&lang=js&"
export * from "./EditH1GoodsItems.vue?vue&type=script&lang=js&"
import style0 from "./EditH1GoodsItems.vue?vue&type=style&index=0&id=7b7d00cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7d00cc",
  null
  
)

export default component.exports